module.exports = __webpack_public_path__ + "static/media/MP_QR.16848df8.jpeg";